import MuiClickAwayListener from '@material-ui/core/ClickAwayListener';

export default MuiClickAwayListener;
